import { NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, RouterModule, Routes } from '@angular/router';
import { Subscription } from 'rxjs';
import { CONSTANTS } from './core/constants/constants';
import { ROUTES } from './core/constants/routes';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { DataSharingService } from './core/services/data-sharing/data-sharing.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: `/${ROUTES.EXTERNAL.PATH}`,
    pathMatch: 'full',
  },
  {
    path: ROUTES.DASHBOARD.PATH,
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: ROUTES.EXTERNAL.PATH,
    loadChildren: () => import('./modules/external/external.module').then((m) => m.ExternalModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {
  private _subscription = new Subscription();

  constructor(router: Router, title: Title, dataSharingService: DataSharingService) {
    this._subscription = router.events.subscribe(() => {
      title.setTitle(
        `${CONSTANTS.APP_TITLE} - ${dataSharingService.currentRoute$.getValue()?.TITLE}`,
      );
    });
  }

  onDestroy(): void {
    this._subscription.unsubscribe();
  }
}
